/**
 * DashboardHeaderSkeleton — placeholder while the lazy
 * `<DashboardHeader>` chunk is loading.
 *
 * Pulled out of `PortfolioDashboard.tsx` (Phase c — Portfolio Off-Chain
 * splitting). Pure presentation, no state. The shape matches the
 * eventual layout : 4 metric tiles in a row + 3 chart panels in a
 * 1fr/2fr/1.2fr grid.
 *
 * Lives next to `DashboardHeader.tsx` so the lazy import + its
 * fallback stay co-located.
 */

const tileBase = {
  background: 'var(--card-bg)',
  borderRadius: '12px',
  border: '1px solid var(--border)',
  animation: 'pulse 1.5s ease-in-out infinite',
} as const;

export function DashboardHeaderSkeleton() {
  return (
    <div
      aria-hidden
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        marginBottom: '20px',
      }}
    >
      {/* Metrics skeleton — 4 tiles. */}
      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
        {[1, 2, 3, 4].map((i) => (
          <div key={i} style={{ ...tileBase, flex: '1 1 150px', height: '85px' }} />
        ))}
      </div>
      {/* Charts skeleton — 3 panels in a 1fr/2fr/1.2fr grid. */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 2fr 1.2fr',
          gap: '16px',
          minHeight: '220px',
        }}
      >
        {[1, 2, 3].map((i) => (
          <div key={i} style={tileBase} />
        ))}
      </div>
    </div>
  );
}
